import { render, staticRenderFns } from "./PopitWin.vue?vue&type=template&id=0ebeb1d8&scoped=true&"
import script from "./PopitWin.vue?vue&type=script&lang=js&"
export * from "./PopitWin.vue?vue&type=script&lang=js&"
import style0 from "./PopitWin.vue?vue&type=style&index=0&id=0ebeb1d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebeb1d8",
  null
  
)

export default component.exports